import { Component, ViewChild, OnInit, OnDestroy, Input } from '@angular/core';
import { Chart } from 'chart.js';
import { Statistics, Tool } from '../../models';
import * as moment from 'moment';

const intervalFormat = {
  year: 'YYYY',
  month: 'MMMM',
  week: '[Week:] w',
  day: 'MMM Do',
  hour: 'HH:mm',
};

@Component({
  selector: 'app-bar-chart',
  template: `
    <div>
      <canvas #barChart style="height:300px;">{{ chart }}</canvas>
    </div>
  `,
})
export class BarChartComponent implements OnInit, OnDestroy {
  @ViewChild('barChart', { static: true }) private chartRef;
  @Input() interval: 'year' | 'month' | 'week' | 'day' | 'hour' = 'hour';
  @Input() tool = Tool.Email;
  @Input() timeFormat = 'll';

  @Input() set statistics(statistics: Statistics[]) {
    const stats = [...statistics].slice(1);

    if (this.chart) {
      this.chart.data = {
        labels: stats.map((stat, index) => {
          const date = moment(statistics[index].timestamp).add(1, 'ms');

          if (
            [0, stats.length - 1].includes(index) &&
            ['year', 'month', 'week'].includes(this.interval)
          ) {
            const dayDiff = moment(stat.timestamp)
              .add(1, 'ms')
              .diff(date, 'day');
            return `${date.format(
              intervalFormat[this.interval],
            )} (${dayDiff} days)`;
          }

          return date.format(intervalFormat[this.interval]);
        }),
        datasets: [
          {
            backgroundColor: '#1B7A91',
            label: 'Sent',
            data: stats.map(({ sent }) => sent),
          },
          {
            backgroundColor: '#72C3B2',
            label: 'Delivered',
            data: stats.map(({ normalizedDelivered }) => normalizedDelivered),
          },
          {
            backgroundColor: '#E2696A',
            label: 'Bounced',
            data: stats.map(({ uniqueBounce }) => uniqueBounce),
          },
          ...(this.tool === Tool.Email
            ? [
                {
                  backgroundColor: '#000000',
                  label: 'Spam complaints',
                  data: stats.map(({ abuse }) => abuse),
                },
              ]
            : []),
        ],
      };
      this.chart.update();
    }
  }

  public chart: Chart;

  ngOnInit(): void {
    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'bar',
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (label) => {
                  if (
                    typeof label === 'number' &&
                    Math.floor(label) === label
                  ) {
                    return label;
                  }
                },
              },
            },
          ],
        },
      },
    });
  }

  ngOnDestroy(): void {
    this.chart.destroy();
  }

  labelGenerator(_: Statistics, index: number) {}
}
